import { useState, useEffect, useMemo } from 'react';

const useYouTubeVideos = (limit = 3) => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Vídeos fixos como fallback (mesmos da página Palavras)
  const fallbackVideos = useMemo(() => [
    {
      id: 'SWu43r8DSy8',
      titulo: 'A FALSA ESPERANÇA GERA SOFRIMENTO',
      thumbnail: 'https://img.youtube.com/vi/SWu43r8DSy8/maxresdefault.jpg',
      data: '10 nov 2025',
      categoria: 'Pregação',
      duracao: '50:23',
          pregador: 'Pastor Anderson Rabis'
    },
    {
        id: 'm9idPlqvjfI',
        titulo: 'MISSÃO CENTRO OESTE,COM O APOSTOLO LUIZ HERMÍNIO ',
        thumbnail: 'https://img.youtube.com/vi/m9idPlqvjfI/maxresdefault.jpg',
      data: '12 out 2025',
     categoria: 'Conferencia',
      duracao: '2:37:56',
      pregador: 'Apostolo Luiz Hermínio'
    },
    {
        id: 'F6bOxLXKoMc&t=16s',
      titulo: 'OBEDIÊNCIA,POSICIONAMENTO  E ENFRETAMENTO',
      thumbnail: 'https://img.youtube.com/vi/F6bOxLXKoMc/maxresdefault.jpg',
      data: '01 jul 2025',
      categoria: 'Pregação',
      duracao: '1:00:38',
      pregador: 'Pastor Anderson Rabis'
    },
    {
        id: 'd81iECeTZ48',
        titulo: 'COMO VENCER AS VOZES DE INTIMIDAÇÃO ',
      thumbnail: 'https://img.youtube.com/vi/d81iECeTZ48/maxresdefault.jpg',
      data: '15 set 2025',
        categoria: 'Pregação',
      duracao: '1:05:45',
        pregador: 'Pastor Anderson Rabis'
    },
    {
        id: 'xBIKHX3eYNA',
      titulo: 'Palavra Profética',
      thumbnail: 'https://img.youtube.com/vi/xBIKHX3eYNA/maxresdefault.jpg',
      data: '22 jul 2025',
        categoria: 'Pregação',
      duracao: '45:20',
      pregador: 'Pastor Anderson Rabis'
    },
    {
      id: 'SWu43r8DSy8',
      titulo: 'COMUNICAÇÃO PROFETICA - O EVANGELIO PARA OS IMPROVÁVEIS ',
      thumbnail: 'https://img.youtube.com/vi/SWu43r8DSy8/maxresdefault.jpg',
      data: '27 mai 2025',
      categoria: 'Pregação',
      duracao: '48:18',
      pregador: 'Pastor Anderson Rabis'
    }
  ], []);

  useEffect(() => {
    const fetchYouTubeVideos = async () => {
      try {
        setLoading(true);
        
        // Tenta buscar do canal MEVAM Brasília (mesmo método da página Palavras)
        const corsProxy = 'https://api.allorigins.win/raw?url=';
        
        // Buscar via RSS Feed (não precisa de API Key)
          const channelId = 'UC2ILVabVRlfIsD8GYd4Rflw'; // Substitua pelo ID real do canal
        const rssFeedUrl = `https://www.youtube.com/feeds/videos.xml?channel_id=${channelId}`;
        
        const rssResponse = await fetch(corsProxy + encodeURIComponent(rssFeedUrl), {
          signal: AbortSignal.timeout(5000) // Timeout de 5 segundos
        });
        
        if (!rssResponse.ok) {
          throw new Error('Erro ao buscar feed');
        }
        
        const rssText = await rssResponse.text();
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(rssText, 'text/xml');
        
        const entries = Array.from(xmlDoc.querySelectorAll('entry')).slice(0, limit);
        
        if (entries.length === 0) {
          throw new Error('Nenhum vídeo encontrado');
        }
        
        const fetchedVideos = entries.map(entry => {
          const videoId = entry.querySelector('videoId')?.textContent || '';
          const title = entry.querySelector('title')?.textContent || '';
          const published = entry.querySelector('published')?.textContent || '';
          
          // Formatar data
          const date = new Date(published);
          const dateStr = date.toLocaleDateString('pt-BR', { 
            day: '2-digit', 
            month: 'short' 
          }).replace('.', '');
          
          // Determinar categoria baseado no título
          let categoria = 'Mensagens';
          if (title.toLowerCase().includes('convenção')) {
            categoria = 'Convenção Internacional';
          } else if (title.toLowerCase().includes('culto profético')) {
            categoria = 'Culto Profético';
          } else if (title.toLowerCase().includes('jovens')) {
            categoria = 'Rede de Jovens';
          }
          
          return {
            id: videoId,
            titulo: title,
            thumbnail: `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`,
            data: dateStr,
            categoria: categoria,
            duracao: '—',
            pregador: 'MEVAM Brasília'
          };
        });
        
        setVideos(fetchedVideos);
        setError(null);
      } catch (err) {
        console.warn('Erro ao buscar vídeos do YouTube, usando fallback:', err);
        // Usa vídeos fixos como fallback
        setVideos(fallbackVideos.slice(0, limit));
        setError(null); // Não mostra erro para o usuário, apenas usa fallback
      } finally {
        setLoading(false);
      }
    };

    fetchYouTubeVideos();
  }, [limit, fallbackVideos]);

  return { videos, loading, error };
};

export default useYouTubeVideos;
